





    import Vue from 'vue';
    import Component from 'vue-class-component';

    @Component({
        name: "bankList",
        components: {},
        mixins:[]
    })
    export default class bankList extends Vue {
        public created():void {
            // on componenet created
        }
        public mounted():void {
            // on componenet mounted
        }
    }
